import { render, staticRenderFns } from "./valmistumispyynnon-hyvaksynta-yek.vue?vue&type=template&id=7170b437&scoped=true&"
import script from "./valmistumispyynnon-hyvaksynta-yek.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnon-hyvaksynta-yek.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnon-hyvaksynta-yek.vue?vue&type=style&index=0&id=7170b437&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7170b437",
  null
  
)

export default component.exports